export default __webpack_public_path__ + "static/media/CMEInProgress.9652720d.svg";